/**
 * A conversão do radar em PNG para o documento, como `svgParaPngBase64` do legado
 * (`admin.html:4978-5000`): o SVG vira imagem, é desenhado num canvas quadrado e sai em base64.
 *
 * Mora separada da montagem do documento porque depende do navegador (Blob, Image, canvas), e a
 * montagem é regra pura.
 */

/** Converte a marcação SVG num PNG quadrado de `tamanhoPx`, como `data:` URI. */
export function svgParaPngBase64(svgMarkup: string, tamanhoPx: number): Promise<string> {
  return new Promise((resolve, reject) => {
    // O SVG como arquivo em memória, para a imagem carregar dele.
    const blob = new Blob([svgMarkup], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = tamanhoPx;
      canvas.height = tamanhoPx;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        URL.revokeObjectURL(url);
        reject(new Error('Não consegui converter o radar em imagem.'));
        return;
      }
      // DEFEITO DO LEGADO REPRODUZIDO (achado da A3, fora da seção 4): `var(--surface)` não é uma
      // cor que o canvas entenda, então a atribuição é ignorada e o fundo sai na cor padrão do
      // canvas, preta (`admin.html:4987`). A suíte da A3 mede o pixel.
      ctx.fillStyle = 'var(--surface)';
      ctx.fillRect(0, 0, tamanhoPx, tamanhoPx);
      ctx.drawImage(img, 0, 0, tamanhoPx, tamanhoPx);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      // A frase do legado, que o Dossiê só registra no console e segue sem a imagem.
      reject(new Error('Não consegui converter o radar em imagem.'));
    };
    img.src = url;
  });
}
